import { axios } from 'shared/services/axios'
import ORGANIZATION_IMAGE_CATEGORIES from 'common/constants/organizationImageCategories'
import isEmpty from 'lodash/isEmpty'

export const IMAGES_TYPES = {
  webpage: "webpage",
  document: "document",
  board: "board",
  campaign: "campaign",
  promotion: "promotion",
  imageBank: "image_bank",
  webpageImageBank: "webpage_image_bank"
}

export function fetchImageGallery(params) {
  return axios.post(`/api/imagegallery`, params )
    .then(response => response.data)
}

export const fetchBoardImages = (params) => {
  return fetchImageGallery({
    ...params,
    type: IMAGES_TYPES.board,
    edit: false
  })
}

export const fetchCampaignImages = () => {
  return fetchImageGallery({ type: IMAGES_TYPES.campaign })
}

export const fetchOrganizationImages = (organizationImageType, organizationId) => {
  return fetchImageGallery({
    type: IMAGES_TYPES.imageBank,
    bank_category: organizationImageType,
    organization_id: organizationId
  })
}

export const fetchWebpageOrganizationImages = (organizationId, url) => {
  return fetchImageGallery({
    type: IMAGES_TYPES.webpageImageBank,
    bank_category: ORGANIZATION_IMAGE_CATEGORIES.thumbnails,
    organization_id: organizationId,
    url
  })
}

export const fetchWebpageImages = ({url, currentImage = {}}) => {
  const params = {
    type: IMAGES_TYPES.webpage,
    url,
    edit: false
  }

  if(!isEmpty(currentImage)) {
    params.images = [currentImage]
    params.edit = true
  }

  return fetchImageGallery(params)
}

export const fetchDocumentImages = ({fileName, currentImage = {}}) => {
  return fetchImageGallery({
    type: IMAGES_TYPES.document,
    file_name: fileName,
    edit: true,
    images: isEmpty(currentImage) ? [] : [currentImage]
  })
}

export const fetchPromotionImages = () => {
  return fetchImageGallery({ type: IMAGES_TYPES.promotion })
}
